import AmountDisplay from 'assets/icons/amount-display.svg?react';
import Apply from 'assets/icons/apply.svg?react';
import ArrowCircle from 'assets/icons/arrow-circle.svg?react';
import ArrowDown from 'assets/icons/arrow-down.svg?react';
import FullArrowDown from 'assets/icons/arrow-down-full.svg?react';
import FillRightArrow from 'assets/icons/arrow-fill-right.svg?react';
import MinimalRightArrow from 'assets/icons/arrow-right.svg?react';
import Bank from 'assets/icons/bank.svg?react';
import Bell from 'assets/icons/bell.svg?react';
import BellFull from 'assets/icons/bell-full.svg?react';
import Blacklist from 'assets/icons/blacklist.svg?react';
import Block from 'assets/icons/block.svg?react';
import BlockFill from 'assets/icons/block-fill.svg?react';
import Calculate from 'assets/icons/calculate.svg?react';
import Calendar from 'assets/icons/calendar.svg?react';
import CalendarPreset from 'assets/icons/calendarPreset.svg?react';
import Card from 'assets/icons/card.svg?react';
import ChartBar from 'assets/icons/chartBar.svg?react';
import Check from 'assets/icons/check.svg?react';
import CheckCircle from 'assets/icons/check-circle.svg?react';
import Clarity from 'assets/icons/clarity.svg?react';
import Clear from 'assets/icons/clear.svg?react';
import Clock from 'assets/icons/clock.svg?react';
import Close from 'assets/icons/close.svg?react';
import Comment from 'assets/icons/comment.svg?react';
import Confirm from 'assets/icons/confirm.svg?react';
import Copy from 'assets/icons/copy.svg?react';
import Currency from 'assets/icons/currency.svg?react';
import Customer from 'assets/icons/customer.svg?react';
import DangerExclamation from 'assets/icons/danger-exclamation.svg?react';
import Delete from 'assets/icons/delete.svg?react';
import Desktop from 'assets/icons/desctop.svg?react';
import DoubleArrows from 'assets/icons/doubleArrows.svg?react';
import Download from 'assets/icons/download.svg?react';
import DownloadFile from 'assets/icons/download-file.svg?react';
import Downloads from 'assets/icons/downloads.svg?react';
import DragDots from 'assets/icons/drag-dots.svg?react';
import Edit from 'assets/icons/edit.svg?react';
import Eye from 'assets/icons/eye.svg?react';
import EyeClosed from 'assets/icons/eye-closed.svg?react';
import File from 'assets/icons/file.svg?react';
import Filters from 'assets/icons/filters.svg?react';
import FormatBold from 'assets/icons/format-bold.svg?react';
import FormatItalic from 'assets/icons/format-italic.svg?react';
import FormatListBulleted from 'assets/icons/format-list-bulleted.svg?react';
import FormatListNumbered from 'assets/icons/format-list-numbered.svg?react';
import FormatUnderline from 'assets/icons/format-underline.svg?react';
import Globe from 'assets/icons/globe.svg?react';
import Hierarchy from 'assets/icons/hierarchy.svg?react';
import History from 'assets/icons/history.svg?react';
import Id from 'assets/icons/id.svg?react';
import Image from 'assets/icons/image.svg?react';
import Invisible from 'assets/icons/invisible.svg?react';
import Kibana from 'assets/icons/kibana.svg?react';
import LeftArrow from 'assets/icons/left-arrow.svg?react';
import Less from 'assets/icons/less.svg?react';
import Link from 'assets/icons/link.svg?react';
import List from 'assets/icons/list.svg?react';
import LocalTime from 'assets/icons/localTime.svg?react';
import Lock from 'assets/icons/lock.svg?react';
import Logo from 'assets/icons/logo.svg?react';
import LongArrowDown from 'assets/icons/long-arrow-down.svg?react';
import LongArrowDownBold from 'assets/icons/long-arrow-down-bold.svg?react';
import MagicStick from 'assets/icons/magic-stick.svg?react';
import Letter from 'assets/icons/mail.svg?react';
import AuditLog from 'assets/icons/menu/audit-log.svg?react';
import AuthAuditLog from 'assets/icons/menu/auth-audit-log.svg?react';
import BinGroups from 'assets/icons/menu/bin-groups.svg?react';
import Blacklists from 'assets/icons/menu/blacklists.svg?react';
import CashierLimits from 'assets/icons/menu/cashier-limits.svg?react';
import CashierSettings from 'assets/icons/menu/cashier-settings.svg?react';
import Clients from 'assets/icons/menu/clients.svg?react';
import ClientsInstruments from 'assets/icons/menu/clients-instruments.svg?react';
import ClientsList from 'assets/icons/menu/clients-list.svg?react';
import CountryGroups from 'assets/icons/menu/country-groups.svg?react';
import Dashboards from 'assets/icons/menu/dashboards.svg?react';
import HomeMenu from 'assets/icons/menu/home.svg?react';
import IntegrationBuilder from 'assets/icons/menu/integration-builder.svg?react';
import Invoices from 'assets/icons/menu/invoice.svg?react';
import Logout from 'assets/icons/menu/logout.svg?react';
import MerchantGroups from 'assets/icons/menu/merchant-groups.svg?react';
import Merchants from 'assets/icons/menu/merchants.svg?react';
import MerchantsSettingsMenu from 'assets/icons/menu/merchants-settings.svg?react';
import MessageCenter from 'assets/icons/menu/message-center.svg?react';
import MetadataTemplates from 'assets/icons/menu/metadata-templates.svg?react';
import OrganizationsMenu from 'assets/icons/menu/organizations.svg?react';
import PaymentMethods from 'assets/icons/menu/payment-methods.svg?react';
import PSP from 'assets/icons/menu/psp.svg?react';
import PSPManagement from 'assets/icons/menu/psp-management.svg?react';
import Reconciliation from 'assets/icons/menu/reconciliation.svg?react';
import ResultCodes from 'assets/icons/menu/result-codes.svg?react';
import RolesPermissions from 'assets/icons/menu/roles-permissions.svg?react';
import RoutingRuleset from 'assets/icons/menu/routing-ruleset.svg?react';
import SettingMenu from 'assets/icons/menu/setting.svg?react';
import Settlement from 'assets/icons/menu/settlement.svg?react';
import SettlementContracts from 'assets/icons/menu/settlement-contracts.svg?react';
import StylizationMenu from 'assets/icons/menu/stylization.svg?react';
import TerminalLinks from 'assets/icons/menu/terminal-links.svg?react';
import TerminalLinksGroups from 'assets/icons/menu/terminal-links-groups.svg?react';
import TerminalLinksLimits from 'assets/icons/menu/terminal-links-limits.svg?react';
import TerminalLinksParameters from 'assets/icons/menu/terminal-links-parameters.svg?react';
import Terminals from 'assets/icons/menu/terminals.svg?react';
import TrafficManagement from 'assets/icons/menu/traffic-management.svg?react';
import TransactionMenu from 'assets/icons/menu/transaction.svg?react';
import Users from 'assets/icons/menu/users.svg?react';
import WlStylization from 'assets/icons/menu/wl-stylization.svg?react';
import MinimalLeftArrow from 'assets/icons/minimal-left-arrow.svg?react';
import Mobile from 'assets/icons/mobile.svg?react';
import Moon from 'assets/icons/moon.svg?react';
import More from 'assets/icons/more.svg?react';
import MoreInfo from 'assets/icons/more-info.svg?react';
import MoreInfoFile from 'assets/icons/more-info-file.svg?react';
import ErrorIcon from 'assets/icons/notification/error.svg?react';
import InfoIcon from 'assets/icons/notification/info.svg?react';
import SuccessIcon from 'assets/icons/notification/success.svg?react';
import WarningIcon from 'assets/icons/notification/warning.svg?react';
import Notifications from 'assets/icons/notifications.svg?react';
import NotSelected from 'assets/icons/notSelected.svg?react';
import Open from 'assets/icons/open.svg?react';
import Percent from 'assets/icons/percent.svg?react';
import PersonalCard from 'assets/icons/personalCard.svg?react';
import Pin from 'assets/icons/pin.svg?react';
import Plus from 'assets/icons/plus.svg?react';
import PlusCircle from 'assets/icons/plus-circle.svg?react';
import Power from 'assets/icons/power.svg?react';
import Profile from 'assets/icons/profile.svg?react';
import QR from 'assets/icons/qr.svg?react';
import QuestionMark from 'assets/icons/questionMark.svg?react';
import Reconcile from 'assets/icons/reconcile.svg?react';
import Refund from 'assets/icons/refund.svg?react';
import Remove from 'assets/icons/remove.svg?react';
import Repeat from 'assets/icons/repeat.svg?react';
import Reset from 'assets/icons/reset.svg?react';
import ResetFormat from 'assets/icons/reset-format.svg?react';
import SaveFilter from 'assets/icons/save-filter.svg?react';
import Search from 'assets/icons/search.svg?react';
import Settings from 'assets/icons/settings.svg?react';
import Share from 'assets/icons/share.svg?react';
import Shrink from 'assets/icons/shrink.svg?react';
import PickerPointer from 'assets/icons/slider-dot.svg?react';
import Sort from 'assets/icons/sort.svg?react';
import Start from 'assets/icons/start.svg?react';
import Statistics from 'assets/icons/statistics.svg?react';
import StepBack from 'assets/icons/stepBack.svg?react';
import Stretch from 'assets/icons/stretch.svg?react';
import Stylization from 'assets/icons/stylization.svg?react';
import Stylization2 from 'assets/icons/stylization-2.svg?react';
import Sun from 'assets/icons/sun.svg?react';
import Text from 'assets/icons/text.svg?react';
import Tiles from 'assets/icons/tiles.svg?react';
import Traffic from 'assets/icons/traffic.svg?react';
import Undo from 'assets/icons/undo.svg?react';
import UploadFile from 'assets/icons/uploadFile.svg?react';
import User from 'assets/icons/user.svg?react';
import UserFull from 'assets/icons/user-full.svg?react';
import ViewLogs from 'assets/icons/viewLogs.svg?react';
import Visible from 'assets/icons/visible.svg?react';
import DragDropLeft from 'assets/images/dragDropLeft.svg?react';
import DragDropRight from 'assets/images/dragDropRight.svg?react';
import EmptySearch from 'assets/images/errorPages/empty-search.svg?react';
import NotFound from 'assets/images/errorPages/not-found.svg?react';
import PermissionDenied from 'assets/images/errorPages/permission-denied.svg?react';
import SomethingWentWrong from 'assets/images/errorPages/something-went-wrong.svg?react';
import Maintenance from 'assets/images/maintainance.svg?react';
import Preview from 'assets/images/preview.svg?react';
import Rotate from 'assets/images/rotate.svg?react';

export const ICONS_MAP = {
  AmountDisplay,
  Apply,
  ArrowCircle,
  ArrowDown,
  AuditLog,
  AuthAuditLog,
  Bank,
  Bell,
  BellFull,
  BinGroups,
  Blacklist,
  Blacklists,
  Block,
  BlockFill,
  Calculate,
  Calendar,
  CalendarPreset,
  Card,
  CashierLimits,
  CashierSettings,
  ChartBar,
  Check,
  CheckCircle,
  Clarity,
  Clear,
  Clients,
  ClientsInstruments,
  ClientsList,
  Clock,
  Close,
  Comment,
  Confirm,
  Copy,
  CountryGroups,
  Currency,
  Customer,
  DangerExclamation,
  Dashboards,
  Delete,
  Desktop,
  DoubleArrows,
  Download,
  DownloadFile,
  Downloads,
  DragDots,
  DragDropLeft,
  DragDropRight,
  Edit,
  EmptySearch,
  Eye,
  EyeClosed,
  File,
  FillRightArrow,
  Filters,
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  FormatUnderline,
  FullArrowDown,
  Globe,
  Hierarchy,
  History,
  HomeMenu,
  Id,
  Image,
  IntegrationBuilder,
  Invisible,
  Invoices,
  Kibana,
  LeftArrow,
  Less,
  Letter,
  Link,
  List,
  LocalTime,
  Lock,
  Logo,
  Logout,
  LongArrowDown,
  LongArrowDownBold,
  MagicStick,
  Maintenance,
  MerchantGroups,
  Merchants,
  MerchantsSettingsMenu,
  MessageCenter,
  MetadataTemplates,
  MinimalLeftArrow,
  MinimalRightArrow,
  Mobile,
  Moon,
  More,
  MoreInfo,
  MoreInfoFile,
  NotFound,
  NotificationError: ErrorIcon,
  NotificationInfo: InfoIcon,
  Notifications,
  NotificationSuccess: SuccessIcon,
  NotificationWarning: WarningIcon,
  NotSelected,
  Open,
  OrganizationsMenu,
  PaymentMethods,
  Percent,
  PermissionDenied,
  PersonalCard,
  PickerPointer,
  Pin,
  Plus,
  PlusCircle,
  Power,
  Preview,
  Profile,
  PSP,
  PSPManagement,
  QR,
  QuestionMark,
  Reconcile,
  Reconciliation,
  Refund,
  Remove,
  Repeat,
  Reset,
  ResetFormat,
  ResultCodes,
  RolesPermissions,
  Rotate,
  RoutingRuleset,
  SaveFilter,
  Search,
  SettingMenu,
  Settings,
  Settlement,
  SettlementContracts,
  Share,
  Shrink,
  SomethingWentWrong,
  Sort,
  Start,
  Statistics,
  StepBack,
  Stretch,
  Stylization,
  Stylization2,
  StylizationMenu,
  Sun,
  TerminalLinks,
  TerminalLinksGroups,
  TerminalLinksLimits,
  TerminalLinksParameters,
  Terminals,
  Text,
  Tiles,
  Traffic,
  TrafficManagement,
  TransactionMenu,
  Undo,
  UploadFile,
  User,
  UserFull,
  Users,
  ViewLogs,
  Visible,
  WlStylization,
};
